function tryGetFrames(window: Window) {
    try {
        return Array.from(window.frames);
    } catch {
        return [];
    }
}

function getUniqueTargetFrames(): Window[] {
    const frames: Window[] = [window, window.top!];
    tryGetFrames(window.top!).forEach((target) => {
        frames.push(target);
        tryGetFrames(target).forEach((item) => {
            frames.push(item);
        });
    });

    return Array.from(new Set(frames));
}

export function publish(topic: string, message: any) {
    getUniqueTargetFrames().forEach((target) => {
        try {
            target.postMessage({ id: topic, message: message, data: message }, "*");
        } catch (ex) {
            console.error(ex);
        }
    });
}

export function getMessageKeys(key: string) {
    return {
        fromCmsKey: `${key}:cms`,
        fromDeliveryKey: `${key}:delivery`,
    };
}

export const commonMessageTypes = {
    screenshot: getMessageKeys("/site/screenshot"),
};
